import CmsPageComponent from "../../../components/commonComponents/CMSPage/CmsPageComponent";
import "../cmspagescommon.css"
const ReturnPolicyPage = () => {
  return <CmsPageComponent header={"Return Policy"} type="ReturnPolicy" />;
};

export default ReturnPolicyPage;
